module.exports = __webpack_public_path__ + "media/images/talent/button-googlplay-bf408d2d907cb10ea4748a98a848ec25.svg";